module.exports = __webpack_public_path__ + "static/media/section4.ae6577b8.png";